// src/Features/ServicesForms/Components/EuroRailForm.jsx
import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from "react";
import "./EuroRailForm.css";
import { Accordion, Col, Row, Form } from "react-bootstrap";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { SingleCalendar } from "../../../../components";
import SignatureCanvas from "react-signature-canvas";
import { ReactComponent as UploadIcon } from "../../../../assets/images/icons/solar_upload-line-duotone.svg";
import { useTranslation } from "../../../../contexts/TranslationContext";
import axios from "axios";
import debounce from "lodash.debounce";
import { TravelerSelector } from "../../../../components";
import Cookies from "js-cookie";
import { axiosGet } from "../../../../utils/apis/api";

const EuroRailForm = forwardRef(
  (
    {
      onChange = () => {},
      showErrors = false,
      initialData = null,
      selectedDates,
      url,
    },
    ref
  ) => {
    const [previewImage, setPreviewImage] = useState(null);
    const [showModal, setShowModal] = useState(false);

    /* -------------------------------------------------------------------- state */
    const { t } = useTranslation();
    const Lang = Cookies.get("preferred_language") || "en";
    const [activeAccordionKeys, setActiveAccordionKeys] = useState(["0"]);
    const [infants, setInfants] = useState(0);
    /* -------------------------------- state -------------------------------- */
    const [form, setForm] = useState({
      /* personal */
      full_name: "",
      date_of_birth: null,
      gender: "",
      nationality: "",
      passport_number: "",
      phone: "",
      email: "",
      address: "",
      /* info */
      departure_station: null,
      arrival_station: null,
      departure_date: null,
      return_date: null,
      train_type: null,
      class_of_travel: null,
      number_of_passengers_adults: 1,
      number_of_passengers_children: 0,
      ages: [],
      preferred_operator: null,
      destination: null,
      destination_name: "",
      special_requests: null,
      /* payment */
      payment_method: null,
      billing_address: "",
      invoice_required: "",
      /* travel & contact */
      flight_details: "",
      contact_person_dest: "",
      /* uploads + declaration */
      files: {},
      agree_terms: false,
      signature: "",
    });

    const fieldToAccordionMap = {
      // Personal Information (0)
      full_name: "0",
      date_of_birth: "0",
      gender: "0",
      nationality: "0",
      passport_number: "0",
      phone: "0",
      email: "0",

      // Booking Details (1)
      departure_station: "1",
      arrival_station: "1",
      departure_date: "1",
      return_date: "1",
      train_type: "1",
      class_of_travel: "1",
      children_ages: "1",
      preferred_operator: "1",
      destination: '1',
      special_requests: "1",

      // Payment & Billing (2)
      payment_method: "2",
      billing_address: "2",
      invoice_required: "2",

      // Travel & Contact (3)
      contact_person_dest: "3",

      // Supporting Documents (4)
      file_passport_copy: "4",

      // Declaration & Signature (5)
      agree_terms: "5",
      signature: "5",
    };

    const [errors, setErrors] = useState({});
    const [natQuery, setNatQuery] = useState("");
    const [natOptions, setNatOptions] = useState([]);
    const [natLoading, setNatLoading] = useState(false);
    // const fetchNationalities = useMemo(
    //   () =>
    //     debounce(async (q = "") => {
    //       try {
    //         setNatLoading(true);
    //         const params = q ? { search: q, limit: 20 } : { limit: 20 };
    //         const { data } = await axios.get(
    //           "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.api.countries",
    //           { params }
    //         );
    //         setNatOptions(data.result.countries || []);
    //       } catch (e) {
    //         console.error(e);
    //       } finally {
    //         setNatLoading(false);
    //       }
    //     }, 300),
    //   []
    // );

    const fetchNationalities = useMemo(
      () =>
        debounce(async (q = "") => {
          try {
            setNatLoading(true);

            const params = q ? { search: q, limit: 20 } : { limit: 20 };

            const data = await axiosGet(
              "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.api.countries",
              params
            );

            setNatOptions(data?.result?.countries || []);
          } catch (e) {
            console.error(e);
          } finally {
            setNatLoading(false);
          }
        }, 300),
      []
    );

    

    useEffect(() => {
      fetchNationalities(natQuery);
    }, [natQuery, fetchNationalities]);

    useEffect(() => () => fetchNationalities.cancel(), [fetchNationalities]);

    const [destQuery, setDestQuery] = useState("");
    const [destOptions, setDestOptions] = useState([]);
    const [destLoading, setDestLoading] = useState(false);

    // const fetchDestinations = useMemo(
    //   () =>
    //     debounce(async (q = "") => {
    //       try {
    //         setDestLoading(true);
    //         const baseParams = { location_type: "City", limit: 20 };
    //         const params =
    //           q.length >= 2 ? { ...baseParams, search: q } : baseParams;
    //         const { data } = await axios.get(
    //           "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.api.locations",
    //           { params }
    //         );
    //         setDestOptions(data.result.locations || []);
    //       } catch (e) {
    //         console.error(e);
    //       } finally {
    //         setDestLoading(false);
    //       }
    //     }, 300),
    //   []
    // );

    const fetchDestinations = useMemo(
      () =>
        debounce(async (q = "") => {
          try {
            setDestLoading(true);

            const baseParams = { location_type: "City", limit: 20 };
            const params =
              q.length >= 2 ? { ...baseParams, search: q } : baseParams;

            const data = await axiosGet(
              "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.api.locations",
              params
            );

            setDestOptions(data?.result?.locations || []);
          } catch (e) {
            console.error(e);
          } finally {
            setDestLoading(false);
          }
        }, 300),
      []
    );

    useEffect(() => {
      if (destQuery.length >= 2) fetchDestinations(destQuery);
    }, [destQuery, fetchDestinations]);

    useEffect(() => () => fetchDestinations.cancel(), [fetchDestinations]);
    

    /* -------------------------------------------------------------------- uploads */
    const inputRefs = useRef({});
    const sigPadRef = useRef();

    // Restore signature from initialData
    useEffect(() => {
      if (initialData?.signature && sigPadRef.current) {
        sigPadRef.current.fromDataURL(initialData.signature);
      }
    }, [initialData]);

    /* -------------------------------------------------------------------- select options */
    const trainTypeOptions = [
      { name: "High-Speed", label: t("HighSpeed") },
      { name: "Scenic", label: t("Scenic") },
      { name: "Night Train", label: t("NightTrain") },
      { name: "Regional", label: t("Regional") },
    ];
    const travelClassOptions = [
      { name: "Standard", label: t("Standard") },
      { name: "First Class", label: t("FirstClass") },
      { name: "Sleeper", label: t("Sleeper") },
    ];

    // const specialRequestsOptions = [
    //   { name: "seat_preferences", label: t("SeatPreferences") },
    //   { name: "wheelchair", label: t("Wheelchair") },
    //   { name: "assistance", label: t("Assistance") },
    // ];
    const paymentMethodOptions = [
      { name: "Credit Card", label: t("CreditCard") },
      { name: "PayPal", label: t("PayPal") },
      { name: "Bank Transfer", label: t("BankTransfer") },
    ];

    const required = {
      full_name: t("FullNameIsRequired"),
      date_of_birth: t("DateOfBirthIsRequired"),
      gender: t("GenderIsRequired"),
      nationality: t("NationalityIsRequired"),
      passport_number: t("PassportNumberIsRequired"),
      phone: t("PhoneNumberIsRequired"),
      email: t("EmailAddressIsRequired"),
      departure_station: t("DepartureStationIsRequired"),
      destination: t("DestinationCountryRequired"),
      arrival_station: t("ReturnStationIsRequired"),
      departure_date: t("DepartureDateRequired"),
      return_date: t("ReturnDateRequired"),
      train_type: t("TrainTypeIsRequired"),
      class_of_travel: t("ClassOfTravelIsRequired"),
      payment_method: t("PaymentMethodIsRequired"),
      billing_address: t("BillingAddressIsRequired"),
      invoice_required: t("PleaseSpecifyIfInvoiceIsRequired"),
      agree_terms: t("YouMustAgreeToTheTerms"),
      signature: t("SignatureIsRequired"),
    };

    const requiredFiles = { passport_copy: t("PassportCopyIsRequired") };
    const rangeErrors = { trip: t("ReturnDateMustBeAfterDepartureDate") };

    const validate = () => {
      const errs = {};
      Object.entries(required).forEach(([k, msg]) => {
        if (!form[k] || (typeof form[k] === "string" && !form[k].trim()))
          errs[k] = msg;
      });

      Object.entries(requiredFiles).forEach(([k, msg]) => {
        if (!form.files[k]) errs[`file_${k}`] = msg;
      });

      if (
        form.departure_date &&
        form.return_date &&
        new Date(form.departure_date) > new Date(form.return_date)
      ) {
        errs.return_date = rangeErrors.trip;
      }

      if (
        form.number_of_passengers_children > 0 &&
        (form.ages.length < form.number_of_passengers_children ||
          form.ages.includes(null) ||
          form.ages.includes(0))
      ) {
        errs.children_ages = t("ValidationChildrenAge");
      }

      if (form.email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(form.email)) {
          errs.email = t("EmailValidation");
        }
      }

      if (form.phone) {
        const phoneRegex = /^\+?[0-9]{6,15}$/;
        if (!phoneRegex.test(form.phone))
          errs.phone = t("InvalidPhoneNumberFormat");
      }

      if (form.contact_person_dest) {
        const phoneRegex = /^\+?[0-9]{6,15}$/;
        if (!phoneRegex.test(form.contact_person_dest))
          errs.contact_person_dest = t("InvalidPhoneNumberFormat");
      }

      setErrors(errs);
      return Object.keys(errs).length === 0;
    };

    useEffect(() => {
      onChange(form, validate());
    }, [form]);

    const handleFileChange = (k, f) => {
      if (!f) return;
      setForm((p) => ({ ...p, files: { ...p.files, [k]: f } }));
      if (inputRefs.current[k]) inputRefs.current[k].value = null;
    };

    const handleFileRemove = (k) => {
      setForm((p) => {
        const files = { ...p.files };
        delete files[k];
        return { ...p, files };
      });
      if (inputRefs.current[k]) inputRefs.current[k].value = null;
    };

    const truncate = (n, max = 28) =>
      !n ? "" : n.length <= max ? n : `${n.slice(0, max - 6)}...${n.slice(-5)}`;

    const fileDisplayName = (f) =>
      typeof f === "string" ? f.split("/").pop() : f.name;

    const err = (f) => showErrors && errors[f];

    // Initialize form from initialData
    useEffect(() => {
      if (!initialData) return;
      const toDate = (s) => (s ? new Date(s) : null);
      setForm({
        ...initialData,
        date_of_birth: toDate(initialData.date_of_birth),
        departure_date: initialData.departure_date
          ? new Date(initialData.departure_date)
          : null,
        return_date: initialData.return_date
          ? new Date(initialData.return_date)
          : null,
      });
      onChange(initialData, true);
    }, [initialData]);

    // Auto-expand accordions when errors appear
    useEffect(() => {
      if (showErrors && Object.keys(errors).length > 0) {
        const errorAccordionKeys = Object.keys(errors)
          .map((field) => fieldToAccordionMap[field])
          .filter((key) => key !== undefined);

        setActiveAccordionKeys((prev) => [
          ...prev,
          ...errorAccordionKeys.filter((key) => !prev.includes(key)),
        ]);
      }
    }, [showErrors, errors]);

    const scrollToFirstError = () => {
      const firstErrorKey = Object.keys(errors)[0];
      if (firstErrorKey) {
        // Expand accordion section containing the error
        const accordionKey = fieldToAccordionMap[firstErrorKey];
        if (accordionKey && !activeAccordionKeys.includes(accordionKey)) {
          setActiveAccordionKeys((prev) => [...prev, accordionKey]);
        }

        // Scroll to field after accordion expands
        setTimeout(() => {
          const element = document.getElementById(`field-${firstErrorKey}`);
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 300);
      }
    };

    // Expose scroll method via ref
    useImperativeHandle(ref, () => ({
      scrollToFirstError,
    }));

    /* ────────────────────────────────── JSX ───────────────────────────────────── */
    return (
      <Accordion
        alwaysOpen
        className="hotel-form-accordion add-service-form-accordion services-euroRail-form-accordion-container"
        activeKey={activeAccordionKeys}
        onSelect={(keys) => setActiveAccordionKeys(keys)}
      >
        {/* 1. Personal Information */}
        <Accordion.Item eventKey="0" className="hotel-form-accordion-item">
          <Accordion.Header className="hotel-form-accordion-header">
            1. {t("PersonalInformation")}
          </Accordion.Header>
          <Accordion.Body className="hotel-form-accordion-body">
            <Row>
              {/* Full name */}
              <Col xl={4} md={6}>
                <div
                  className="hotel-form-input-container"
                  id="field-full_name"
                >
                  <label className="hotel-form-input-label">
                    {t("FullNameAsPerPassport")}
                    <span>*</span>
                  </label>
                  <input
                    className="hotel-form-input"
                    value={form.full_name}
                    onChange={(e) =>
                      setForm((p) => ({ ...p, full_name: e.target.value }))
                    }
                    placeholder={t("FullName")}
                  />
                  {err("full_name") && (
                    <div className="field-error">{errors.full_name}</div>
                  )}
                </div>
              </Col>

              {/* Date of Birth */}
              <Col xl={4} md={6}>
                <div
                  className="hotel-form-input-container"
                  id="field-date_of_birth"
                >
                  <label className="hotel-form-input-label">
                    {t("DateOfBirth")} <span>*</span>
                  </label>
                  <SingleCalendar
                    value={form.date_of_birth}
                    onChange={(e) =>
                      setForm((p) => ({ ...p, date_of_birth: e.value }))
                    }
                    placeholder={t("DateOfBirth")}
                    showTime={false}
                    max={new Date()}
                  />
                  {err("date_of_birth") && (
                    <div className="field-error">{errors.date_of_birth}</div>
                  )}
                </div>
              </Col>

              {/* Gender */}
              <Col xl={4} md={6}>
                <div className="hotel-form-input-container" id="field-gender">
                  <label className="hotel-form-input-label">
                    {t("Gender")} <span>*</span>
                  </label>
                  <Form.Select
                    size="sm"
                    value={form.gender}
                    onChange={(e) =>
                      setForm((p) => ({ ...p, gender: e.target.value }))
                    }
                    className="hotel-form-input select-dropdown"
                  >
                    <option value="" disabled>
                      {t("SelectGender")}
                    </option>
                    <option value="Male">{t("Male")}</option>
                    <option value="Female">{t("Female")}</option>
                  </Form.Select>
                  {err("gender") && (
                    <div className="field-error">{errors.gender}</div>
                  )}
                </div>
              </Col>

              {/* Nationality */}
              <Col xl={4} md={6}>
                <div
                  className="hotel-form-input-container"
                  id="field-nationality"
                >
                  <label className="hotel-form-input-label">
                    {t("Nationality")} <span>*</span>
                  </label>
                  <Autocomplete
                    options={natOptions}
                    loading={natLoading}
                    getOptionLabel={(o) => o.name || ""}
                    dir={Lang === "ar" ? "rtl" : "ltr"}
                    value={
                      natOptions.find((o) => o.name === form.nationality) ||
                      null
                    }
                    onInputChange={(_, v) => setNatQuery(v)}
                    onChange={(_, v) =>
                      setForm((p) => ({ ...p, nationality: v?.name || "" }))
                    }
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder={t("SelectNationality")}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                        }}
                      />
                    )}
                  />
                  {err("nationality") && (
                    <div className="field-error">{errors.nationality}</div>
                  )}
                </div>
              </Col>

              {/* Passport Number */}
              <Col xl={4} md={6}>
                <div
                  className="hotel-form-input-container"
                  id="field-passport_number"
                >
                  <label className="hotel-form-input-label">
                    {t("PassportNumber")} <span>*</span>
                  </label>
                  <input
                    className="hotel-form-input"
                    value={form.passport_number}
                    onChange={(e) =>
                      setForm((p) => ({
                        ...p,
                        passport_number: e.target.value,
                      }))
                    }
                    placeholder={t("PassportNumber")}
                  />
                  {err("passport_number") && (
                    <div className="field-error">{errors.passport_number}</div>
                  )}
                </div>
              </Col>

              {/* Phone */}
              <Col xl={4} md={6}>
                <div className="hotel-form-input-container" id="field-phone">
                  <label className="hotel-form-input-label">
                    {t("ContactNumber")} <span>*</span>
                  </label>
                  <input
                    className="hotel-form-input"
                    value={form.phone}
                    onChange={(e) =>
                      setForm((p) => ({ ...p, phone: e.target.value }))
                    }
                    placeholder={t("ContactNumber")}
                  />
                  {err("phone") && (
                    <div className="field-error">{errors.phone}</div>
                  )}
                </div>
              </Col>

              {/* Email */}
              <Col xl={4} md={6}>
                <div className="hotel-form-input-container" id="field-email">
                  <label className="hotel-form-input-label">
                    {t("Email")} <span>*</span>
                  </label>
                  <input
                    type="email"
                    className="hotel-form-input"
                    value={form.email}
                    onChange={(e) =>
                      setForm((p) => ({ ...p, email: e.target.value }))
                    }
                    placeholder={t("Email")}
                  />
                  {err("email") && (
                    <div className="field-error">{errors.email}</div>
                  )}
                </div>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>

        {/* 2. Euro Rail Booking Details */}
        <Accordion.Item eventKey="1" className="hotel-form-accordion-item">
          <Accordion.Header className="hotel-form-accordion-header">
            2. {t("EuroRailBookingDetails")}
          </Accordion.Header>
          <Accordion.Body className="hotel-form-accordion-body">
            <Row>
              <Col xl={4} md={6}>
                <div
                  className="hotel-form-input-container"
                  id="field-departure-station"
                >
                  <label className="hotel-form-input-label">
                    {t("DepartureStation")}
                    {" ("} {t("CityOrTrainStation")}
                    {" )"}
                    <span>*</span>
                  </label>
                  <input
                    className="hotel-form-input"
                    type="text"
                    value={form.departure_station}
                    onChange={(e) =>
                      setForm((p) => ({
                        ...p,
                        departure_station: e.target.value,
                      }))
                    }
                    placeholder={t("DepartureStation")}
                  />
                  {err("departure_station") && (
                    <div className="field-error">
                      {errors.departure_station}
                    </div>
                  )}
                </div>
              </Col>

              <Col xl={4} md={6}>
                <div
                  className="hotel-form-input-container"
                  id="field-arrival-station"
                >
                  <label className="hotel-form-input-label">
                    {t("ArrivalStation")}
                    {" ("} {t("CityOrTrainStation")}
                    {" )"}
                    <span>*</span>
                  </label>
                  <input
                    className="hotel-form-input"
                    type="text"
                    value={form.arrival_station}
                    onChange={(e) =>
                      setForm((p) => ({
                        ...p,
                        arrival_station: e.target.value,
                      }))
                    }
                    placeholder={t("ArrivalStation")}
                  />
                  {err("arrival_station") && (
                    <div className="field-error">{errors.arrival_station}</div>
                  )}
                </div>
              </Col>

              {/* Dates */}
              <Col xl={4} md={6}>
                <div
                  className="hotel-form-input-container"
                  id="field-departure_date"
                >
                  <label className="hotel-form-input-label">
                    {t("DepartureDate")} <span>*</span>
                  </label>
                  <SingleCalendar
                    value={form.departure_date}
                    onChange={(e) =>
                      setForm((p) => ({ ...p, departure_date: e.value }))
                    }
                    placeholder={t("DepartureDate")}
                    min={new Date(selectedDates.startDate)}
                    max={
                      form.return_date
                        ? new Date(
                            Math.min(
                              new Date(form.return_date).getTime(),
                              new Date(selectedDates.endDate).getTime()
                            )
                          )
                        : new Date(selectedDates.endDate)
                    }
                    viewDate={new Date(selectedDates.startDate)}
                  />
                  {err("departure_date") && (
                    <div className="field-error">{errors.departure_date}</div>
                  )}
                </div>
              </Col>

              <Col xl={4} md={6}>
                <div
                  className="hotel-form-input-container"
                  id="field-return_date"
                >
                  <label className="hotel-form-input-label">
                    {t("ReturnDate")} <span>*</span>
                  </label>
                  <SingleCalendar
                    value={form.return_date}
                    onChange={(e) =>
                      setForm((p) => ({ ...p, return_date: e.value }))
                    }
                    placeholder={t("ReturnDate")}
                    min={
                      form.departure_date
                        ? new Date(
                            Math.max(
                              new Date(form.departure_date).getTime(),
                              new Date(selectedDates.startDate).getTime()
                            )
                          )
                        : new Date(selectedDates.startDate)
                    }
                    max={new Date(selectedDates.endDate)}
                    viewDate={new Date(selectedDates.endDate)}
                  />
                  {err("return_date") && (
                    <div className="field-error">{errors.return_date}</div>
                  )}
                </div>
              </Col>

              {/* train Type */}
              <Col xl={4} md={6}>
                <div
                  className="hotel-form-input-container"
                  id="field-train_type"
                >
                  <label className="hotel-form-input-label">
                    {t("TrainType")} <span>*</span>
                  </label>
                  <Autocomplete
                    options={trainTypeOptions}
                    getOptionLabel={(o) => o.label || ""}
                    dir={Lang === "ar" ? "rtl" : "ltr"}
                    value={
                      trainTypeOptions.find(
                        (opt) => opt.name === form.train_type
                      ) || null
                    }
                    onChange={(_, v) =>
                      setForm((p) => ({ ...p, train_type: v?.name || "" }))
                    }
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder={t("Select")}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        key={option.name}
                        style={{
                          fontFamily:
                            Lang === "ar" ? "Almarai300" : "Dmsans400",
                          direction: Lang === "ar" ? "rtl" : "ltr",
                          textAlign: Lang === "ar" ? "right" : "left",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                  {err("train_type") && (
                    <div className="field-error">{errors.train_type}</div>
                  )}
                </div>
              </Col>

              {/* class Type */}
              <Col xl={4} md={6}>
                <div
                  className="hotel-form-input-container"
                  id="field-class_of_travel"
                >
                  <label className="hotel-form-input-label">
                    {t("ClassOfTravel")} <span>*</span>
                  </label>
                  <Autocomplete
                    options={travelClassOptions}
                    getOptionLabel={(o) => o.label || ""}
                    dir={Lang === "ar" ? "rtl" : "ltr"}
                    value={
                      travelClassOptions.find(
                        (opt) => opt.name === form.class_of_travel
                      ) || null
                    }
                    onChange={(_, v) =>
                      setForm((p) => ({ ...p, class_of_travel: v?.name || "" }))
                    }
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder={t("Select")}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        key={option.name}
                        style={{
                          fontFamily:
                            Lang === "ar" ? "Almarai300" : "Dmsans400",
                          direction: Lang === "ar" ? "rtl" : "ltr",
                          textAlign: Lang === "ar" ? "right" : "left",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                  {err("class_of_travel") && (
                    <div className="field-error">{errors.class_of_travel}</div>
                  )}
                </div>
              </Col>

              {/* Number of Passengers */}
              <Col xl={4} md={6}>
                <div
                  className="hotel-form-input-container"
                  id="field-children_ages"
                >
                  <label className="hotel-form-input-label">
                    {t("NumberOfPassengers")}
                  </label>
                  <TravelerSelector
                    adults={form.number_of_passengers_adults}
                    children={form.number_of_passengers_children}
                    childrenAges={form.ages}
                    infants={infants}
                    onAdultsChange={(v) =>
                      setForm((p) => ({ ...p, number_of_passengers_adults: v }))
                    }
                    onChildrenChange={(v) =>
                      setForm((p) => ({
                        ...p,
                        number_of_passengers_children: v,
                      }))
                    }
                    onChildrenAgesChange={(v) =>
                      setForm((p) => ({ ...p, ages: v }))
                    }
                    onInfantsChange={setInfants}
                  />
                  {err("children_ages") && (
                    <div className="field-error">{errors.children_ages}</div>
                  )}
                </div>
              </Col>

              {/* Preferred Cruise Line */}
              <Col xl={4} md={6}>
                <div className="hotel-form-input-container">
                  <label className="hotel-form-input-label">
                    {t("PreferredOperator")}
                  </label>
                  <input
                    className="hotel-form-input"
                    value={form.preferred_operator}
                    onChange={(e) =>
                      setForm((p) => ({
                        ...p,
                        preferred_operator: e.target.value,
                      }))
                    }
                    placeholder={t("PreferredOperator")}
                  />
                </div>
              </Col>
              {/* Destination */}
              <Col xl={4} md={6}>
                <div
                  className="hotel-form-input-container"
                  id="field-destination"
                >
                  <label className="hotel-form-input-label">
                    {t("DestinationCountryCountries")} <span>*</span>
                  </label>
                  <Autocomplete
                    options={destOptions}
                    loading={destLoading}
                    getOptionLabel={(o) => {
                      const city = (o.location_name || "")
                        .replace(/\s+/g, " ")
                        .trim();
                      const parent = (o.parent_location_name || "")
                        .replace(/\s+/g, " ")
                        .trim();
                      return parent ? `${city} (${parent})` : city;
                    }}
                    value={
                      form.destination
                        ? {
                            name: form.destination,
                            location_name: form.destination_name || "",
                          }
                        : null
                    }
                    onOpen={() => !destOptions.length && fetchDestinations()}
                    onInputChange={(_, v, r) =>
                      r === "input" && setDestQuery(v)
                    }
                    onChange={(_, v) =>
                      setForm((p) => ({
                        ...p,
                        destination: v?.name || null,
                        destination_name: v?.location_name || "",
                      }))
                    }
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                    }}
                    renderInput={(p) => (
                      <TextField
                        {...p}
                        size="small"
                        placeholder={t("SelectCountryOrCity")}
                        InputProps={{
                          ...p.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                        }}
                      />
                    )}
                  />
                  {err("destination") && (
                    <div className="field-error">{errors.destination}</div>
                  )}
                </div>
              </Col>

              {/* Special Requests */}
              <Col xl={12}>
                <div className="hotel-form-input-container">
                  <label className="hotel-form-input-label">
                    {t("SpecialRequestHint")}
                  </label>
                  <textarea
                    rows="3"
                    value={form.special_requests}
                    className="hotel-form-input"
                    onChange={(e) =>
                      setForm((p) => ({
                        ...p,
                        special_requests: e.target.value,
                      }))
                    }
                    placeholder={t("EnterAnySpecialRequests")}
                  />
                </div>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>

        {/* 3. Payment & Billing Information */}
        <Accordion.Item eventKey="2" className="hotel-form-accordion-item">
          <Accordion.Header className="hotel-form-accordion-header">
            3. {t("PaymentAndBillingInformation")}
          </Accordion.Header>
          <Accordion.Body className="hotel-form-accordion-body">
            <Row>
              {/* Payment Method */}
              <Col xl={4} md={6}>
                <div
                  className="hotel-form-input-container"
                  id="field-payment_method"
                >
                  <label className="hotel-form-input-label">
                    {t("PaymentMethod")} <span>*</span>
                  </label>
                  <Autocomplete
                    options={paymentMethodOptions}
                    getOptionLabel={(o) => o.label || ""}
                    dir={Lang === "ar" ? "rtl" : "ltr"}
                    value={
                      paymentMethodOptions.find(
                        (opt) => opt.name === form.payment_method
                      ) || null
                    }
                    onChange={(_, v) =>
                      setForm((p) => ({ ...p, payment_method: v?.name || "" }))
                    }
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder={t("Select")}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        key={option.name}
                        style={{
                          fontFamily:
                            Lang === "ar" ? "Almarai300" : "Dmsans400",
                          direction: Lang === "ar" ? "rtl" : "ltr",
                          textAlign: Lang === "ar" ? "right" : "left",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                  {err("payment_method") && (
                    <div className="field-error">{errors.payment_method}</div>
                  )}
                </div>
              </Col>

              {/* Billing address */}
              <Col xl={8} md={6}>
                <div
                  className="hotel-form-input-container"
                  id="field-billing_address"
                >
                  <label className="hotel-form-input-label">
                    {t("BillingAddress")} <span>*</span>
                  </label>
                  <input
                    className="hotel-form-input"
                    value={form.billing_address}
                    onChange={(e) =>
                      setForm((p) => ({
                        ...p,
                        billing_address: e.target.value,
                      }))
                    }
                    placeholder={t("BillingAddress")}
                  />
                  {err("billing_address") && (
                    <div className="field-error">{errors.billing_address}</div>
                  )}
                </div>
              </Col>

              {/* Invoice Required */}
              <Col xl={12}>
                <div
                  className="add-service-form-checkbox-container"
                  id="field-invoice_required"
                >
                  <div className="add-service-form-checkbox-title">
                    {t("InvoiceRequired")}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </div>
                  <Form className="add-service-form-checkboxes">
                    {["1", "0"].map((v) => (
                      <Form.Check
                        key={v}
                        inline
                        type="radio"
                        label={v === "1" ? t("Yes") : t("No")}
                        name="invoiceRequired"
                        value={v}
                        checked={form.invoice_required === v}
                        onChange={() =>
                          setForm((p) => ({ ...p, invoice_required: v }))
                        }
                        className="add-service-form-checkbox"
                      />
                    ))}
                  </Form>
                  {err("invoice_required") && (
                    <div className="field-error">{errors.invoice_required}</div>
                  )}
                </div>
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>

        {/* 4. Travel & Contact Details */}
        <Accordion.Item eventKey="3" className="hotel-form-accordion-item">
          <Accordion.Header className="hotel-form-accordion-header">
            4. {t("TravelAndContactDetails")}
          </Accordion.Header>
          <Accordion.Body className="hotel-form-accordion-body">
            <Row>
              {[
                {
                  key: "flight_details",
                  label: t("FlightDetailsIfApplicable"),
                  mandatory: 0,
                },
                {
                  key: "contact_person_dest",
                  label: t("ContactPersonAtDestinationIfApplicable"),
                  mandatory: 0,
                },
              ].map(({ key, label, mandatory }) => (
                <Col xl={4} md={6} key={key}>
                  <div
                    className="hotel-form-input-container"
                    id={`field-${key}`}
                  >
                    <label className="hotel-form-input-label">
                      {label} {mandatory ? <span>*</span> : null}
                    </label>
                    <input
                      className="hotel-form-input"
                      value={form[key]}
                      onChange={(e) =>
                        setForm((p) => ({ ...p, [key]: e.target.value }))
                      }
                      placeholder={label}
                    />
                    {key === "contact_person_dest" &&
                      err("contact_person_dest") && (
                        <div className="field-error">
                          {errors.contact_person_dest}
                        </div>
                      )}
                  </div>
                </Col>
              ))}
            </Row>
          </Accordion.Body>
        </Accordion.Item>

        {/* 5. Supporting Documents */}
        <Accordion.Item eventKey="4" className="hotel-form-accordion-item">
          <Accordion.Header className="hotel-form-accordion-header">
            5. {t("SupportedDocuments")} ({t("Uploads")})
          </Accordion.Header>
          <Accordion.Body className="hotel-form-accordion-body">
            <Row>
              {[
                {
                  key: "passport_copy",
                  label: t("PassportCopy"),
                  mandatory: 1,
                },
                {
                  key: "visa_required",
                  label: t("VisaIfRequired"),
                  mandatory: 0,
                },
                {
                  key: "travel_insurance",
                  label: t("TravelInsuranceIfRequired"),
                  mandatory: 0,
                },
                {
                  key: "special_permits",
                  label: t("SpecialTravelPermitsIifApplicable"),
                  mandatory: 0,
                },
              ].map(({ key, label, mandatory }) => {
                const file = form?.files[key];
                const isPdf =
                  file?.name?.toLowerCase().endsWith(".pdf") ||
                  (typeof file === "string" &&
                    file.toLowerCase().endsWith(".pdf"));
                return (
                  <Col xl={6} md={6} key={key}>
                    <div
                      className="hotel-form-input-container"
                      id={`field-file_${key}`}
                    >
                      <label className="hotel-form-input-label">
                        {label} {mandatory ? <span>*</span> : null}
                      </label>
                      <div className="custom-upload-wrapper">
                        <input
                          id={`file-${key}`}
                          type="file"
                          accept=".pdf,.jpg,.jpeg,.png"
                          style={{ display: "none" }}
                          ref={(el) => (inputRefs.current[key] = el)}
                          onChange={(e) =>
                            handleFileChange(key, e.target.files[0])
                          }
                        />

                        {file ? (
                          <div className="custom-upload-box">
                            <div className="file-info">
                              {isPdf ? (
                                <a
                                  href={
                                    typeof file === "string"
                                      ? `${url}${file}`
                                      : URL.createObjectURL(file)
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="file-link"
                                >
                                  {truncate(fileDisplayName(file))}
                                  <span className="file-type-badge">PDF</span>
                                </a>
                              ) : (
                                <span className="file-name">
                                  {truncate(fileDisplayName(file))}
                                </span>
                              )}
                            </div>

                            <div className="file-actions">
                              <button
                                type="button"
                                className="file-action-btn view-file-btn"
                                onClick={() => {
                                  if (isPdf) {
                                    window.open(
                                      typeof file === "string"
                                        ? `${url}${file}`
                                        : URL.createObjectURL(file),
                                      "_blank"
                                    );
                                  } else {
                                    const imageUrl =
                                      typeof file === "string"
                                        ? `${url}${file}`
                                        : URL.createObjectURL(file);
                                    setPreviewImage(imageUrl);
                                    setShowModal(true);
                                  }
                                }}
                              >
                                {isPdf ? t("View") : t("Preview")}
                              </button>

                              <button
                                type="button"
                                className="file-action-btn remove-file-btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileRemove(key);
                                }}
                              >
                                {t("Remove")}
                              </button>
                            </div>
                          </div>
                        ) : (
                          <label
                            htmlFor={`file-${key}`}
                            className="custom-upload-box"
                          >
                            <span className="upload-placeholder">
                              {t("Supported")}: {t("Jpeg")}, {t("Png")},{" "}
                              {t("Pdf")}
                            </span>
                            <UploadIcon className="upload-svg-icon" />
                          </label>
                        )}
                      </div>
                      {err(`file_${key}`) && (
                        <div className="field-error" style={{ marginTop: 5 }}>
                          {errors[`file_${key}`]}
                        </div>
                      )}
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Accordion.Body>
        </Accordion.Item>

        {/* 6. Declaration & Signature */}
        <Accordion.Item eventKey="5" className="hotel-form-accordion-item">
          <Accordion.Header className="hotel-form-accordion-header">
            6. {t("DeclarationAndSignature")}
          </Accordion.Header>
          <Accordion.Body className="hotel-form-accordion-body">
            <Row>
              {/* Terms */}
              <Col xl={12}>
                <div
                  className="hotel-form-input-container"
                  id="field-agree_terms"
                >
                  <Form.Check
                    type="checkbox"
                    label={t("agreeHint")}
                    checked={form.agree_terms}
                    onChange={(e) =>
                      setForm((p) => ({ ...p, agree_terms: e.target.checked }))
                    }
                  />
                  {err("agree_terms") && (
                    <div className="field-error">{errors.agree_terms}</div>
                  )}
                </div>
              </Col>

              {/* Signature */}
              <Col xl={6}>
                <label className="hotel-form-input-label">
                  {t("Signature")} <span>*</span>
                </label>
                <div
                  className="signature-container"
                  style={{ position: "relative" }}
                  id="field-signature"
                >
                  <SignatureCanvas
                    ref={sigPadRef}
                    penColor="black"
                    canvasProps={{
                      width: 500,
                      height: 150,
                      className: "sigCanvas",
                    }}
                    onEnd={() =>
                      setForm((p) => ({
                        ...p,
                        signature: sigPadRef.current.toDataURL(),
                      }))
                    }
                  />
                  <button
                    type="button"
                    title="Clear"
                    onClick={() => {
                      sigPadRef.current.clear();
                      setForm((p) => ({ ...p, signature: "" }));
                    }}
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 40,
                      background: "none",
                      border: "none",
                      fontSize: 18,
                    }}
                  >
                    ⟳
                  </button>
                </div>
                {err("signature") && (
                  <div className="field-error">{errors.signature}</div>
                )}
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
        {previewImage && (
          <div
            className={`modal fade ${
              showModal ? "show d-block" : ""
            } service-files-modal`}
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            onClick={() => setShowModal(false)}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowModal(false)}
                ></button>
                <div className="service-image-file">
                  <img
                    // src={initialData ? `${url}${previewImage}` : previewImage}
                    src={previewImage}
                    alt="preview"
                    style={{ maxWidth: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </Accordion>
    );
  }
);

export default EuroRailForm;
